import { Box, Typography } from "@mui/material";
import { get, isArray } from "lodash";
import React, { FC } from "react";
import DownloadFileFromComponent from "src/components/ui-component/form-component/form-fields/fields/DownloadFileFromComponent";
import MarkdownRenderer from "src/components/ui-component/markdown-renderer/MarkdownRenderer";
import { useApplication } from "src/context/ApplicationContext";
import { FOERDERPROGRAMM_DATEIEN_JE_VN_PATHS } from "src/lib/constants/componentsPath";

// import Schemas
import VerwendungsnachweisSchema from "src/lib/paths/verwendungsnachweis_FULL_Paths.json";
const P = VerwendungsnachweisSchema.attributes;

const DownloadsVN: FC<{}> = () => {
  const { application } = useApplication();

  const foerderprogramm = get(
    application,
    P.Foerderantrag.schema.attributes.Foerderprogramm.path,
    {},
  );
  const paths = FOERDERPROGRAMM_DATEIEN_JE_VN_PATHS;

  const programmSpezifischInhalt = get(foerderprogramm, paths.Inhalt, "");
  const programmSpezifischDateien = get(foerderprogramm, paths.DateienBlock, []);

  const hasProgrammSpezifischTitel =
    isArray(programmSpezifischDateien) &&
    programmSpezifischDateien.some((item: any) => item?.Titel);

  return (
    <>
      <ProgrammSpezifischDateien
        programmSpezifischInhalt={programmSpezifischInhalt}
        programmSpezifischDateien={programmSpezifischDateien}
        hasTitel={hasProgrammSpezifischTitel}
      />
    </>
  );
};

export default DownloadsVN;

const ProgrammSpezifischDateien: FC<{
  programmSpezifischInhalt: string;
  programmSpezifischDateien: any[];
  hasTitel: boolean;
}> = ({ programmSpezifischInhalt, programmSpezifischDateien, hasTitel }) => {
  if (hasTitel || programmSpezifischInhalt) {
    return (
      <>
        <Box sx={{ mt: "1rem" }}>
          <Typography variant="h3" component={"h3"}>
            Downloads
          </Typography>
          <MarkdownRenderer markdown={programmSpezifischInhalt} />
          <DownloadFileFromComponent
            component={programmSpezifischDateien}
            filePathInComponent="Datei"
          />
        </Box>
      </>
    );
  }

  return <></>;
};
